import {createTheme} from "@mui/material";

export const OAUTH_CALLBACK_URL = `${process.env.REACT_APP_UI_BASE_URL}/oauth`;

export const ACCESS_TOKEN_LOCAL_STORAGE_KEY = 'accessToken';
export const REFRESH_TOKEN_LOCAL_STORAGE_KEY = 'refreshToken';

export const HILIGHT_COLOR = "#38D59C"
export const DISABLED_COLOR = "#757575"
export const WARN_COLOR = "#d32f2f"

export const theme = createTheme({
    palette: {
        primary: {
            light: HILIGHT_COLOR,
            main: HILIGHT_COLOR,
            dark: HILIGHT_COLOR,
            contrastText: HILIGHT_COLOR,
        },
        info: {
            light: 'white',
            main: 'white',
            dark: 'white',
            contrastText: 'white',
        }
    }
})